import { Component, inject, Input, OnInit } from '@angular/core';
import { TableOfContent } from '../../../models/types';
import { Observable, of } from 'rxjs';
import { ICONS_PATH_PREFIX } from '../../../utils/constant';
import { PriceListArea, PriceListAreaEnum } from '../../../models/pricelist-area.model';
import { AsyncPipe, LowerCasePipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { SharedDataStore } from '../../../store';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-table-of-content',
  imports: [LowerCasePipe, NgForOf, NgClass, AsyncPipe, NgIf],
  templateUrl: './table-of-content.component.html',
  styleUrls: ['./table-of-content.component.scss', './print-table-of-content.component.scss'],
})
export class TableOfContentComponent implements OnInit {
  @Input() tableOfContents$: Observable<TableOfContent[]> | undefined;
  @Input() area: PriceListArea | undefined;

  currentYear$: Observable<string | undefined>;
  completeTableOfContents$!: Observable<TableOfContent[]>;
  footerImagePath!: string;

  private readonly sharedDataStore = inject(SharedDataStore);

  ngOnInit(): void {
    this.footerImagePath = `${ICONS_PATH_PREFIX}${this.area === PriceListAreaEnum.ROW ? 'row-table-of-content-footer.png' : 'eu-table-of-content-footer.png'}`;
    this.tableOfContents$.subscribe((tableOfContents) => {
      this.completeTableOfContents$ = of([
        ...tableOfContents,
        {
          title: 'Online Courses',
          items: ['Online Courses'],
        },
        {
          title: 'Other',
          items: ['Public Holidays', 'Terms & Conditions'],
        },
      ]);
    });
    this.currentYear$ = this.sharedDataStore.currentPriceListYear$;
  }
}
